import React, { useEffect, useState } from "react";
import Joinus from "../../common/Joinus";
import { initialStates, servicesppc, gridppc, ppcServiceDetails } from "../home/Constant";
import DigitalPpcAni from "./DigitalPpcAni";
import WhatWeDo from "./WhatWeDo";

const DigitalPpc = () => {
  const [showAll, setShowAll] = useState(false);
  const colors = ["#ffc250", "#e9536c", "#f4b1b8", "#1eacc0"];
  useEffect(() => {
    const handleScroll = () => {
      const currentY = window.scrollY;
      console.log(`Scr ${currentY.toFixed(0)}px`);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);


  return (
    <div className="margin-topall">
      <section className="py-5 service-position">
        <div className="container">
          <div className="metappc-bg-round">
            {colors.map((color, i) => (
              <div
                key={i}
                id={`dot_00${i}`}
                style={{
                  position: "absolute",
                  border: `${i == 0 ? "9px solid white" : "none"}`,
                  top: `${initialStates[i].top}px`,
                  left: `${initialStates[i].left}px`,
                  width: `${initialStates[i].width}px`,
                  height: `${initialStates[i].height}px`,
                  marginLeft: `${initialStates[i].marginLeft}px`,
                  opacity: initialStates[i].opacity,
                  backgroundColor: color,
                  borderRadius: "50%",
                  zIndex: 1000,
                  pointerEvents: "none",
                  willChange: "top, left, width, height, opacity, margin-left",
                }}
              />
            ))}
          </div>
          <div className="pos-z-index">
            <div className="row justify-content-center">
              <div className="col-lg-10"
                data-aos="fade-right" data-aos-delay="300"
              >
                <div className="">
                  <h5 className="yellow-sub-heading text-center py-2">
                    PPC Advertising Agency
                  </h5>
                  {/* <h4 className="black-service-heading text-center font-align mt-3">
                                    Unlock 5x Revenue Growth
                                </h4> */}
                  <div className="smsppc-sub-heading">
                    A PPC (Pay-Per-Click) campaign is a powerful digital marketing strategy where 
                    advertisers pay only when users click on their ads. As a trusted PPC advertising 
                    agency, we design data-driven campaigns to drive qualified traffic, 
                    generate high-quality leads, and increase sales. PPC advertising delivers 
                    instant visibility, precise audience targeting, and fully measurable results 
                    such as click-through rates (CTR), conversions, and return on ad spend (ROAS). 
                    Our expert PPC management ensures your ads reach users who are actively searching 
                    for your products or services—maximizing every rupee spent.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <WhatWeDo data={ppcServiceDetails} />
      <DigitalPpcAni />
      <section className="overflow-hidden">
        <div className="container">

          {gridppc.map((item, index) => (
            <div className="row gridflex">
              <div className={`col-lg-6 ${index % 2 === 0 ? 'order-lg-1' : 'order-lg-2'}`}
                data-aos={`fade-${index % 2 === 1 ? "left" : "right"}`} data-aos-delay="300"
              >
                <div className="d-flex gap-2">
                  <div className="circleservice">{index + 1}</div>
                  <h1 className="servicebenefit">{item.heading}</h1>
                </div>
                <div className="servicefontb ">
                  <p className="py-2">{item.para1}</p>
                </div>
              </div>
              <div className={`col-lg-6 gridimage ${index % 2 === 0 ? 'order-lg-2' : 'order-lg-1'}`}
                data-aos={`fade-${index % 2 === 1 ? "right" : "left"}`} data-aos-delay="300"
              >
                <img className="bulkwidth" src={item.img} alt={`Visual for ${item.heading}`} />
              </div>
            </div>
          ))}
        </div>
      </section>
      {/* <WhatDo/> */}
      <section className="py-5">
        <div className="container">
          <div>
            <h1 className="faqfont">FAQs - (PPC Campaign)</h1>
          </div>
          <div className="py-5"
            data-aos="fade-right" data-aos-delay="300"
          >
            <div class="accordion" id="accordionExample">
              <div class="accordion-item border-top">
                <h2 class="accordion-header" id="headingOne">
                  <button
                    class="accordion-button d-flex align-items-center"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-expanded="true"
                    aria-controls="collapseOne"
                  >
                    <span class="me-3 toggle-icon"></span>
                    What is PPC advertising?
                  </button>
                </h2>
                <div
                  id="collapseOne"
                  class="accordion-collapse collapse show"
                  aria-labelledby="headingOne"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body sms-span">
                    PPC advertising is a model where advertisers pay each time a
                    user clicks on their ad.
                  </div>
                </div>
              </div>

              <div class="accordion-item border-top">
                <h2 class="accordion-header" id="headingTwo">
                  <button
                    class="accordion-button collapsed d-flex align-items-center"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo"
                    aria-expanded="false"
                    aria-controls="collapseTwo"
                  >
                    <span class="me-3 toggle-icon"></span>
                    What are the benefits of PPC advertising?
                  </button>
                </h2>
                <div
                  id="collapseTwo"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingTwo"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    The benefits of PPC advertising include increased website
                    traffic, lead generation, and sales.
                  </div>
                </div>
              </div>

              <div class="accordion-item border-top">
                <h2 class="accordion-header" id="headingThree">
                  <button
                    class="accordion-button collapsed d-flex align-items-center"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseThree"
                    aria-expanded="false"
                    aria-controls="collapseThree"
                  >
                    <span class="me-3 toggle-icon"></span>
                    How do I set a budget for my PPC campaign?
                  </button>
                </h2>
                <div
                  id="collapseThree"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingThree"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    To set a budget for your PPC campaign, determine your daily
                    or monthly spend, and then allocate it to specific ad groups
                    and campaigns.
                  </div>
                </div>
              </div>

              <div class="accordion-item border-top">
                <h2 class="accordion-header" id="headingFour">
                  <button
                    class="accordion-button collapsed d-flex align-items-center"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFour"
                    aria-expanded="false"
                    aria-controls="collapseFour"
                  >
                    <span class="me-3 toggle-icon"></span>
                    What are the different types of PPC ads?
                  </button>
                </h2>
                <div
                  id="collapseFour"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingFour"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    <ul>
                      <li>
                        <span className="boldspan">Search Ads </span> – Appear
                        on Google & Bing when users search for specific
                        keywords.
                      </li>
                      <li>
                        <span className="boldspan"> Display Ads </span> –
                        Image-based ads shown on websites across the internet.
                      </li>
                      <li>
                        <span className="boldspan"> Social Media Ads</span> –
                        Facebook, Instagram, and LinkedIn ads targeting specific
                        audiences.
                      </li>
                      <li>
                        <span className="boldspan"> Shopping Ads </span> –
                        Google Shopping ads for eCommerce businesses.
                      </li>
                      <li>
                        <span className="boldspan"> Video Ads</span> – YouTube
                        ads shown before or during videos.
                      </li>
                      <li>
                        <span className="boldspan"> Remarketing Ads</span> – Ads
                        shown to people who previously visited your website.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="accordion-item border-top">
                <h2 class="accordion-header" id="headingFive">
                  <button
                    class="accordion-button collapsed d-flex align-items-center"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFive"
                    aria-expanded="false"
                    aria-controls="collapseFive"
                  >
                    <span class="me-3 toggle-icon"></span>
                    How long does it take for PPC to show results?
                  </button>
                </h2>
                <div
                  id="collapseFive"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingFive"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    PPC delivers{" "}
                    <span className="boldspan">instant results</span> once the
                    campaign is live. However,{" "}
                    <span className="boldspan">optimization</span> (A/B testing,
                    audience refinement, and bid adjustments) takes a
                    <span className="boldspan"> few weeks </span>to maximize
                    performance.
                  </div>
                </div>
              </div>
              {showAll && (
                <>
                  <div class="accordion-item border-top">
                    <h2 class="accordion-header" id="headingSix">
                      <button
                        class="accordion-button collapsed d-flex align-items-center"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseSix"
                        aria-expanded="false"
                        aria-controls="collapseSix"
                      >
                        <span class="me-3 toggle-icon"></span>
                        How do I know if my PPC ads are working?
                      </button>
                    </h2>
                    <div
                      id="collapseSix"
                      class="accordion-collapse collapse"
                      aria-labelledby="headingSix"
                      data-bs-parent="#accordionExample"
                    >
                      <div class="accordion-body">
                        <ul>
                          <li>
                            <span className="boldspan">
                              {" "}
                              Click-through rate (CTR){" "}
                            </span>
                            – % of people who click on your ad.
                          </li>
                          <li>
                            <span className="boldspan">
                              {" "}
                              Cost per Click (CPC)
                            </span>{" "}
                            – How much you pay per click.
                          </li>
                          <li>
                            <span className="boldspan"> Conversion Rate</span> –
                            % of visitors who take action (purchase, sign-up,
                            etc.).
                          </li>
                          <li>
                            <span className="boldspan">
                              Return on Ad Spend (ROAS){" "}
                            </span>
                            – Revenue generated from the ads.
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div class="accordion-item border-top">
                    <h2 class="accordion-header" id="headingSeven">
                      <button
                        class="accordion-button collapsed d-flex align-items-center"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseSeven"
                        aria-expanded="false"
                        aria-controls="collapseSeven"
                      >
                        <span class="me-3 toggle-icon"></span>
                        Why is my PPC campaign not performing well?
                      </button>
                    </h2>
                    <div
                      id="collapseSeven"
                      class="accordion-collapse collapse"
                      aria-labelledby="headingSeven"
                      data-bs-parent="#accordionExample"
                    >
                      <div class="accordion-body">
                        <ul>
                          <li>Poor keyword selection or audience targeting.</li>
                          <li>Weak ad copy and landing page experience.</li>
                          <li>Low budget in a competitive industry.</li>
                          <li>High CPC with low conversion rates.</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item border-top">
                    <h2 class="accordion-header" id="headingEight">
                      <button
                        class="accordion-button collapsed d-flex align-items-center"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseEight"
                        aria-expanded="false"
                        aria-controls="collapseEight"
                      >
                        <span class="me-3 toggle-icon"></span>
                        Why should I hire an agency for PPC management?
                      </button>
                    </h2>
                    <div
                      id="collapseEight"
                      class="accordion-collapse collapse"
                      aria-labelledby="headingEight"
                      data-bs-parent="#accordionExample"
                    >
                      <div class="accordion-body">
                        <span className="boldspan">
                          Managing PPC campaigns requires expertise in
                        </span>{" "}
                        keyword research, ad copywriting, bid strategies, and
                        <br /> optimization.
                        <span className="boldspan">
                          {" "}
                          An experienced agency ensures:
                        </span>
                        Better ad performance{" "}
                        <span className="boldspan">and higher ROI.</span>
                        <br />
                        Lower cost-per-click (CPC) with optimized targeting.
                        <br />
                        Continuous monitoring and adjustments for best results.
                      </div>
                    </div>
                  </div>
                </>
              )}
              <div className="text-center py-3 ">
                <button
                  className="btn-sm viewbtn"
                  onClick={() => setShowAll(!showAll)}
                >
                  {showAll ? "View Less" : "View More"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Joinus />
    </div>
  );
};

export default DigitalPpc;
